import { Document } from '@ttab/elephant-api/newsdoc'
import type { TemplatePayload } from './index.js'
import { getSystemLanguage } from '@/shared/getSystemLanguage.js'
import i18n from 'i18next'

/**
 * Generates a document template for type editorial-info
 *
 * @param {string} id - The unique identifier for the article.
 * @param {TemplatePayload} [payload] - Optional payload containing additional template data.
 * @returns {Document} - The generated document template.
 */
export function editorialInfoDocumentTemplate(id: string, payload?: TemplatePayload): Document {
  return Document.create({
    uuid: id,
    type: 'core/editorial-info',
    uri: `core://editorial-info/${id}`, // Migrated documents have core://article/...
    language: payload?.language ?? getSystemLanguage(),
    title: payload?.title,
    // Pre-rendered content, e.g. an auto-generated memo, otherwise an empty
    // heading and body for the editor to fill in.
    content: payload?.content?.length
      ? payload.content
      : [
          {
            type: 'core/text',
            data: {
              text: ''
            },
            role: 'heading-1'
          },
          {
            type: 'core/text',
            data: {
              text: ''
            }
          }
        ],
    meta: [
      {
        type: 'core/note',
        data: {
          text: i18n.t('shared:editorialInfo.noteText')
        },
        role: 'public'
      },
      ...payload?.meta?.['tt/slugline'] || []
    ],
    links: [
      ...payload?.links?.['core/section'] || [],
      ...payload?.links?.['core/editorial-info-type'] || []
    ]
  })
}
